import {
  CameraIcon,
  GrFormNext,
  GrFormPrevious,
  IconFrame,
} from '@element/icons';
import React, { useEffect, useState } from 'react'

function CustomeImageSlider({ item }) {

    const [imageList, setImageList] = useState<any>(item?.imagePaths || [])
    const [showArrows, setShowArrows] = useState(false)
    const [index, setIndex] = useState<any>(0)

    useEffect(() => {
        setIndex(0)
        const images = item?.imagePaths ? item?.imagePaths.filter((i: any) => i.active) : [];
        let showArrow = false;
        setImageList(images);
        if (images.length > 1) showArrow = true;
        if (images.length && item.videoLink) showArrow = true;
        setShowArrows(showArrow)
    }, [item])

    const isIOSDevice = () => {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator?.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

    return (
        <div className='custom-img-slider-wrap'>
            <div className='images-wrap' id="slider">
                {imageList?.map((imageData: any, i: number) => {
                    return <React.Fragment key={i}>
                        <div className="slide" style={{ display: index == i ? 'flex' : 'none' }}>
                            {/* lazy: hidden slides (display:none) should not download until shown */}
                            <img src={imageData.imagePath} loading={index == i ? 'eager' : 'lazy'} decoding="async" />
                        </div>
                    </React.Fragment>
                })}
                {item?.videoLink && <div className="slide vdo-slide" style={{ display: index == imageList.length ? 'flex' : 'none' }}>
                    {(index == imageList.length) &&
                        <>
                            {isIOSDevice() ? <div className='vdo-wrap'>
                                <video autoPlay className="video-background " >
                                    <source src={`${item?.videoLink}?autoplay=1`} type="video/mp4" />
                                </video>
                            </div> : <iframe allowFullScreen className="vdo-frame" src={`${item?.videoLink}?autoplay=1`} allow="autoplay" width={window ? window.innerWidth : "680"} height={"420"}></iframe>}
                        </>
                    }
                </div>}
                {showArrows && <>
                    {index != 0 && <span className="controls" onClick={() => setIndex(index + -1)} id="left-arrow">
                        <GrFormPrevious />
                    </span>}
                    {(item?.videoLink ? (index != imageList.length) : (index != imageList.length - 1)) && <span className="controls" id="right-arrow" onClick={() => setIndex(index + 1)}>
                        <GrFormNext />
                    </span>}
                </>}
            </div>
            {(showArrows) && <div className='thumbnail-wrap' id="thumbnails">
                {imageList?.map((imageData: any, i: number) => {
                    return <React.Fragment key={i}>
                        <div className={`thumbnail ${index == i ? 'active' : ''}`} onClick={() => setIndex(i)}>
                            <img src={imageData.imagePath} loading="lazy" decoding="async" />
                        </div>
                    </React.Fragment>
                })}
                {item?.videoLink && <div className={`thumbnail d-f-c ${index == imageList?.length ? 'active' : ''}`} onClick={() => setIndex(imageList.length)}>
                    <IconFrame><CameraIcon /></IconFrame>
                </div>}
            </div>}
        </div >
    )
}

export default CustomeImageSlider